import React, { useCallback } from 'react';
import { Box, Button, Link } from '@chakra-ui/react';
import RequireClientRole from '#core/Permissions/components/RequireClientRole';

import { useEnvironment } from '#core/Environment';
// JME
// import { useAuthHook } from '#utils/useAuthHook';
// JME1
import { useAuth } from '#core/Auth';

const ErrorFooter: React.FC<{}> = () => {
  const {
    keycloak,
    actions: { logOut },
  }: any = useAuth(); // JME2

  const { baseUrl } = useEnvironment();
  const { authServerUrl, realm } = keycloak || {};

  const handleLogout = useCallback(() => {
    logOut({
      redirectUri: baseUrl,
    });
  }, [logOut, baseUrl]);

  return (
    <>
      <Box p={2}>
        <Button
          data-testid="error-logout"
          variant="solid"
          colorScheme="pink"
          onClick={handleLogout}
        >
          Logout
        </Button>
        <RequireClientRole client="realm-management" role="impersonation">
          <Button
            as={Link}
            href={`${authServerUrl}admin/${realm}/console/#/realms/THE/users`}
            data-testid="error-impersonate"
            variant="solid"
            colorScheme="pink"
            ml={3}
          >
            Impersonate a user
          </Button>
        </RequireClientRole>
      </Box>
      <Box p={2}>
        <Link
          data-testid="the-website-link"
          color="pink.600"
          href="https://www.timeshighereducation.com"
          isExternal
        >
          Go to timeshighereducation.com
        </Link>
      </Box>
    </>
  );
};

export default ErrorFooter;
